<!-- breadcrumb -->
<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Tomografías</h4><span
    class="text-muted mt-1 tx-13 ms-2 mb-0">/ Inicio</span>
  </div>
</div>

</div>


<!-- row opened -->
<div class="row row-sm">
  <div class="col-xl-12">
    <div class="card overflow-visible">

      <div class="card-body">
        @if (spinnerBoolean) {
          <div class="text-center">
            <div class="spinner-grow" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <br>
              <p class="text-center">Consultando por favor espere...</p>
            </div>
          }
          <div class="text-wrap ">
            <div class="example">
              <div class="panel panel-primary tabs-style-3">
                <div class="tab-menu-heading">
                  <div class="tabs-menu">
                    <!-- Tabs -->
                    <ul ngbNav #nav3="ngbNav" class="nav panel-tabs" orientation="horizantal">
                      <li ngbNavItem="1">
                        <a ngbNavLink class=""  (click)="consultarRequerimientos('pendiente', 'vacio')" ><i class="fa fa-cube"></i>&nbsp; Pendientes</a>
                        <ng-template ngbNavContent>

                          @if (posts.length > 0) {
                            <table  datatable [dtOptions]="dtOptions" class="table table-bordered table-striped table-hover">
                              <thead>
                                <tr>
                                  <th>FECHA</th>
                                  <th>CODIGO DOCTOR</th>
                                  <th>NOMBRE DOCTOR</th>
                                  <th>DIRECCION</th>
                                  <th>CELULAR</th>
                                  <th>TALONARIO</th>
                                  <th>CRITERIO PAGO</th>
                                  <th>OBSERVACION</th>
                                  <th>ASESOR</th>
                                  <th>ACCIONES</th>
                                </tr>
                              </thead>
                              <tbody>
                                @for (post of posts; track post; let i = $index) {
                                  <tr>
                                    <td>{{ post.FEC_REQ }}</td>
                                    <td>{{ post.CODNDOC_REQ }}</td>
                                    <td>{{ post.NombreVendedor }}</td>
                                    <td>{{ post.Direccion }}</td>
                                    <td>{{post.TelefonoMovil}}</td>
                                    <td>{{post.Abreviatura}}</td>
                                    <td>
                                      @if (post.estado_gestionhoy!='' && post.estado_gestionhoy!='null' && post.estado_gestionhoy!=null) {
                                        <div>
                                          <i class='fa fa-check text-success'></i>
                                        </div>
                                      }
                                      @if (post.estado_gestionhoy=='' || post.estado_gestionhoy=='null' || post.estado_gestionhoy==null) {
                                        <div>
                                          <i class='fa fa-times text-danger'></i>
                                        </div>
                                      }
                                    </td>
                                    <td>{{post.OBS_REQ}}</td>
                                    <td>{{post.UsuarioAsignado}}</td>
                                    <td>
                                      <div ngbDropdown container="body">
                                        <button class="btn ripple btn-primary btn-sm" ngbDropdownToggle type="button">
                                          <i class="fe fe-settings"></i>
                                        </button>
                                        <div class="tx-13" ngbDropdownMenu>
                                          <div>
                                            <a ngbDropdownItem href="javascript:;" (click)="modalAsignarEntrega(mdlEntregarTomografia, post.CODNDOC_REQ,post.NombreVendedor,post.COD_REQ ,'pendiente', 'vacio')">
                                              <i class="fa fa-user text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;Entregar a paciente o asesor</b>
                                            </a>
                                          </div>
                                          <div>
                                            <a ngbDropdownItem href="javascript:;" (click)="modalEnviarNotificacion(mdlEnviarNotificacion, post.OBS_REQ,post.UsuarioAsignado,post.COD_REQ,'pendiente', 'vacio' )">
                                              <i class="fa fa-location-arrow text-primary" aria-hidden="true"></i> <b>&nbsp;&nbsp;Enviar notificación Asesor (App)</b>
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                }
                              </tbody>
                            </table>
                          }



                        </ng-template>
                      </li>


                      <li ngbNavItem="2">
                        <a ngbNavLink class="" (click)="consultarRequerimientos('Pendiente', 'entrega-asesor')"><i class="fa fa-cube"></i>&nbsp; Entregada asesor</a>
                        <ng-template ngbNavContent>
                          @if (posts.length > 0) {
                            <table  datatable [dtOptions]="dtOptions" class="table table-bordered table-striped table-hover">
                              <thead>
                                <tr>
                                  <th>FECHA</th>
                                  <th>CODIGO DOCTOR</th>
                                  <th>NOMBRE DOCTOR</th>
                                  <th>DIRECCION</th>
                                  <th>CELULAR</th>
                                  <th>TALONARIO</th>
                                  <th>CRITERIO PAGO</th>
                                  <th>OBSERVACION</th>
                                  <th>ASESOR</th>
                                  <th>ACCIONES</th>
                                </tr>
                              </thead>
                              <tbody>
                                @for (post of posts; track post; let i = $index) {
                                  <tr>
                                    <td>{{ post.FEC_REQ }}</td>
                                    <td>{{ post.CODNDOC_REQ }}</td>
                                    <td>{{ post.NombreVendedor }}</td>
                                    <td>{{ post.Direccion }}</td>
                                    <td>{{post.TelefonoMovil}}</td>
                                    <td>{{post.Abreviatura}}</td>
                                    <td>
                                      @if (post.estado_gestionhoy!='' && post.estado_gestionhoy!='null' && post.estado_gestionhoy!=null) {
                                        <div>
                                          <i class='fa fa-check text-success'></i>
                                        </div>
                                      }
                                      @if (post.estado_gestionhoy=='' || post.estado_gestionhoy=='null' || post.estado_gestionhoy==null) {
                                        <div>
                                          <i class='fa fa-times text-danger'></i>
                                        </div>
                                      }
                                    </td>
                                    <td>{{post.OBS_REQ}}</td>
                                    <td>{{post.UsuarioAsignado}}</td>
                                    <td>
                                      <div ngbDropdown container="body">
                                        <button class="btn ripple btn-primary btn-sm" ngbDropdownToggle type="button">
                                          <i class="fe fe-settings"></i>
                                        </button>
                                        <div class="tx-13" ngbDropdownMenu>
                                          <div>
                                            <a ngbDropdownItem href="javascript:;" (click)="marcarAtendido(post.FEC_REQ,post.UsuarioAsignado,post.COD_REQ,'Pendiente', 'entrega-asesor')">
                                              <i class="fa fa-check text-success" aria-hidden="true"></i> <b>&nbsp;&nbsp;Marcar como atendido</b>
                                            </a>
                                          </div>
                                          <div>
                                            <a ngbDropdownItem href="javascript:;" (click)="modalEnviarNotificacion(mdlEnviarNotificacion, post.OBS_REQ,post.UsuarioAsignado,post.COD_REQ,'Pendiente', 'entrega-asesor' )">
                                              <i class="fa fa-location-arrow text-primary" aria-hidden="true" ></i> <b>&nbsp;&nbsp;Enviar notificación Asesor (App)</b>
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                }
                              </tbody>
                            </table>
                          }


                        </ng-template>
                      </li>
                      <li ngbNavItem="3">
                        <a ngbNavLink class="" (click)="consultarRequerimientos('Pendiente', 'entrega-paciente')"><i class="fa fa-cube" ></i>&nbsp; Entregada Paciente</a>
                        <ng-template ngbNavContent>
                          @if (posts.length > 0) {
                            <table  datatable [dtOptions]="dtOptions" class="table table-bordered table-striped table-hover">
                              <thead>
                                <tr>
                                  <th>FECHA</th>
                                  <th>CODIGO DOCTOR</th>
                                  <th>NOMBRE DOCTOR</th>
                                  <th>DIRECCION</th>
                                  <th>CELULAR</th>
                                  <th>TALONARIO</th>
                                  <th>CRITERIO PAGO</th>
                                  <th>OBSERVACION</th>
                                  <th>ASESOR</th>
                                  <th>ACCIONES</th>
                                </tr>
                              </thead>
                              <tbody>
                                @for (post of posts; track post; let i = $index) {
                                  <tr>
                                    <td>{{ post.FEC_REQ }}</td>
                                    <td>{{ post.CODNDOC_REQ }}</td>
                                    <td>{{ post.NombreVendedor }}</td>
                                    <td>{{ post.Direccion }}</td>
                                    <td>{{post.TelefonoMovil}}</td>
                                    <td>{{post.Abreviatura}}</td>
                                    <td>
                                      @if (post.estado_gestionhoy!='' && post.estado_gestionhoy!='null' && post.estado_gestionhoy!=null) {
                                        <div>
                                          <i class='fa fa-check text-success'></i>
                                        </div>
                                      }
                                      @if (post.estado_gestionhoy=='' || post.estado_gestionhoy=='null' || post.estado_gestionhoy==null) {
                                        <div>
                                          <i class='fa fa-times text-danger'></i>
                                        </div>
                                      }
                                    </td>
                                    <td>{{post.OBS_REQ}}</td>
                                    <td>{{post.UsuarioAsignado}}</td>
                                    <td>
                                      <div ngbDropdown container="body">
                                        <button class="btn ripple btn-primary btn-sm" ngbDropdownToggle type="button">
                                          <i class="fe fe-settings"></i>
                                        </button>
                                        <div class="tx-13" ngbDropdownMenu>
                                          <div>
                                            <a ngbDropdownItem href="javascript:;" (click)="marcarAtendido(post.FEC_REQ,post.UsuarioAsignado ,post.COD_REQ,'Pendiente', 'entrega-paciente')">
                                              <i class="fa fa-check text-success" aria-hidden="true" ></i> <b>&nbsp;&nbsp;Marcar como atendido</b>
                                            </a>
                                          </div>
                                          <div>
                                            <a ngbDropdownItem href="javascript:;" (click)="modalEnviarNotificacion(mdlEnviarNotificacion, post.OBS_REQ,post.UsuarioAsignado,post.COD_REQ,'Pendiente', 'entrega-paciente')">
                                              <i class="fa fa-location-arrow text-primary" aria-hidden="true" ></i> <b>&nbsp;&nbsp;Enviar notificación Asesor (App)</b>
                                            </a>
                                          </div>
                                          <div>
                                            <a ngbDropdownItem href="javascript:;" (click)="modalEnviarNotificacionPaciente(mdlEnviarPaciente,post.ORD_REQ)">
                                              <i class="fa fa-location-arrow text-primary" aria-hidden="true" ></i> <b>&nbsp;&nbsp;Enviar notificación Paciente</b>
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                  </tr>
                                }
                              </tbody>
                            </table>
                          }


                        </ng-template>
                      </li>
                      <li ngbNavItem="4"  (click)="consultarRequerimientos('Atendido', 'vacio')">
                        <a ngbNavLink class=""><i class="fa fa-cube"></i>&nbsp; Atendidas</a>
                        <ng-template ngbNavContent>
                          @if (posts.length > 0) {
                            <table  datatable [dtOptions]="dtOptions" class="table table-bordered table-striped table-hover">
                              <thead>
                                <tr>
                                  <th>FECHA</th>
                                  <th>CODIGO DOCTOR</th>
                                  <th>NOMBRE DOCTOR</th>
                                  <th>DIRECCION</th>
                                  <th>CELULAR</th>
                                  <th>TALONARIO</th>
                                  <th>CRITERIO PAGO</th>
                                  <th>OBSERVACION</th>
                                  <th>ASESOR</th>
                                </tr>
                              </thead>
                              <tbody>
                                @for (post of posts; track post; let i = $index) {
                                  <tr>
                                    <td>{{ post.FEC_REQ }}</td>
                                    <td>{{ post.CODNDOC_REQ }}</td>
                                    <td>{{ post.NombreVendedor }}</td>
                                    <td>{{ post.Direccion }}</td>
                                    <td>{{post.TelefonoMovil}}</td>
                                    <td>{{post.Abreviatura}}</td>
                                    <td>
                                      @if (post.estado_gestionhoy!='' && post.estado_gestionhoy!='null' && post.estado_gestionhoy!=null) {
                                        <div>
                                          <i class='fa fa-check text-success'></i>
                                        </div>
                                      }
                                      @if (post.estado_gestionhoy=='' || post.estado_gestionhoy=='null' || post.estado_gestionhoy==null) {
                                        <div>
                                          <i class='fa fa-times text-danger'></i>
                                        </div>
                                      }
                                    </td>
                                    <td>{{post.OBS_REQ}}</td>
                                    <td>{{post.UsuarioAsignado}}</td>
                                  </tr>
                                }
                              </tbody>
                            </table>
                          }


                        </ng-template>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="panel-body tabs-menu-body">
                  <div [ngbNavOutlet]="nav3" class="tab-pane"></div>
                  <div class="tab-content"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- basic Modal -->
    <ng-template #mdlEntregarTomografia let-modal>
      <div class="modal-header">
        <h6 class="modal-title">ENTREGAS TOMOGRAFIAS</h6>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <b>DOCTOR:</b>
        {{codigoDoctor}} - {{nombreDoctor}}<br><br>
        <b>TIPO ENTREGA:</b>
        <select class="form-control"  [(ngModel)]="tipoEntrega">
          <option value="">Seleccione...</option>
          <option value="entrega-asesor">Entregar Asesor</option>
          <option value="entrega-paciente">Entregar a Paciente</option>
        </select>
      </div>
      @if (spinnerBoolean) {
        <div class="text-center">
          <div class="spinner-grow" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <br>
          </div>
        }
        <div class="modal-footer">
          <button type="button" class="btn ripple btn-primary" (click)="actualizarTomografia()" [attr.disabled]="actualizarE ? true : null">Guardar</button>
          <button type="button" class="btn ripple btn-secondary" (click)="modal.close('Save click')">Cerrar</button>
        </div>
      </ng-template>


      <ng-template #mdlEnviarNotificacion let-modal>
        <div class="modal-header">
          <h6 class="modal-title">ENVIO NOTIFICACION ASESOR ({{asesor}})</h6>
          <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <b>INGRESE UNA OBSERVACIÓN</b>
          <input class="form-control" [(ngModel)]="textAreaObservacion" >

        </div>
        @if (spinnerBoolean) {
          <div class="text-center">
            <div class="spinner-grow" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <br>
            </div>
          }
          <div class="modal-footer">
            <button type="button" class="btn ripple btn-primary" (click)="enviarNotificacion()" [attr.disabled]="actualizarE ? true : null">ENVIAR</button>
            <button type="button" class="btn ripple btn-secondary" (click)="modal.close('Save click')">Cerrar</button>
          </div>
        </ng-template>


        <ng-template #mdlEnviarPaciente let-modal>
          <div class="modal-header">
            <h6 class="modal-title">ENVIO NOTIFICACION PACIENTE ({{asesor}})</h6>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <b>INGRESE UNA OBSERVACIÓN</b>
            <input class="form-control" [(ngModel)]="textAreaObservacionPaciente" >

          </div>
          @if (spinnerBoolean) {
            <div class="text-center">
              <div class="spinner-grow" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <br>
              </div>
            }
            <div class="modal-footer">
              <button type="button" class="btn ripple btn-primary" (click)="enviarNotificacionPaciente()" [attr.disabled]="actualizarE ? true : null">ENVIAR</button>
              <button type="button" class="btn ripple btn-secondary" (click)="modal.close('Save click')">Cerrar</button>
            </div>
          </ng-template>
